<script setup>
import { useFilterSidePanel } from '@dashhudson/dashing-ui/filter-side-panel';
import { Toast } from '@dashhudson/dashing-ui/toast';
import { computed } from 'vue';

const { visible } = useFilterSidePanel();

const leftPadding = computed(() => (visible.value ? undefined : '84px'));
</script>

<template>
  <Toast :left-padding="leftPadding" />
</template>
